import { Divider, Stack, Typography } from '@ui-components/neo.tax';

import {
  useAuthRedirect,
  useEmailLink,
  useEnterpriseSsoRequiredNotice,
  useSsoCustomTokenSignIn,
  useWakeBackend,
} from '@neo.tax/onboarding/hooks';
import {
  TestimonialMemo,
  StyledSplitScreen,
  AuthFormHeader,
  SsoButtonsSection,
  StyledInfoContainer,
} from '@neo.tax/onboarding/organisms';
import { AuthType, Loader, useUrlQueryParam } from '@neo.tax/shared';

import { LoginForm } from './organisms';

export const Login = (): React.ReactElement => {
  useWakeBackend();
  // handle redirect sign-in methods
  useSsoCustomTokenSignIn();
  useEmailLink();
  useEnterpriseSsoRequiredNotice();

  // Shown after /verify-email completes for users who end up at /login
  // (e.g. signed out between verifying and returning). A verified-and-signed-in
  // user is redirected past /login by useAuthRedirect before this renders.
  const showVerifiedBanner = useUrlQueryParam('verified') === '1';

  return (
    <Loader useRedirect={useAuthRedirect}>
      <StyledSplitScreen
        leftSide={
          <AuthFormHeader
            pageChangeText="don't have an account?"
            pageChangeLinkText="Sign up"
            pageChangeTo="/signup"
            title="Sign in to your account"
            form={
              <Stack direction="column">
                {showVerifiedBanner ? (
                  <StyledInfoContainer>
                    <Typography as="span" fontSize="sm" fontWeight="medium">
                      Email verified — sign in to continue.
                    </Typography>
                  </StyledInfoContainer>
                ) : null}
                <SsoButtonsSection authType={AuthType.SIGNIN} />
                <Divider>Or continue with</Divider>
                <LoginForm />
              </Stack>
            }
          />
        }
        rightSide={<TestimonialMemo />}
      />
    </Loader>
  );
};
